import React from 'react';
import Label from '../utils/label';

export default class PopupTransBar extends React.Component {
	render() {
		return (
			<div className="um-switching" data-tag="tagMsgSwitching">
				<div className="icon-switch"></div>
				<div className="msgText">
			  		<strong>{Label.lbl_Switchingback}</strong>
					<div className="ani-loading">
						<span></span>
						<span></span>
						<span></span>
					</div>
			  		<p>{Label.lbl_Pleasewaitamoment}</p>
				</div>
		    </div>
		);
	}
}
